import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const investmentContent = {
  title: "投资与风险管理",
  subtitle: "专业的投资咨询服务",
  description: {
    mainText: "专注于为金融机构、资产管理公司及专业投资者提供全方位的投资分析与风险管理解决方案。平台结合先进的大数据分析技术与智能化算法，协助企业精准评估投资风险、优化资产配置组合并实时监控市场动态，有效克服投资决策中的信息不对称、风险评估难度高、资产配置策略难以及时调整等挑战。",
    // systemTitle: "核心功能与特点：",
    // systems: [
    //   "专业市场分析与精准风控：基于实时数据与智能风控模型，精准跟踪证券市场动态，帮助客户迅速识别和规避投资风险。",
    //   "投资组合优化与智能调整：运用遗传算法与AI优化技术，动态调整投资组合策略，实时适应市场环境变化，实现资产组合的高效管理与持续优化。",
    //   "实时数据追踪与智能预警：提供直观的数据可视化分析与敏感性回测工具，实时监测资产表现，助力投资决策的高效执行与风险防控。"
    // ],
    summary: "我们的投资与风险管理系统旨在提高投资决策效率与准确性，助力客户持续获得稳健的资产收益，实现可持续增长，全面保障投资安全与投资回报稳定性。",
    conclusion: {
      title: "应用场景广泛：",
      content: [
        "我们的投资与风险管理系统旨在提高投资决策效率与准确性，助力客户持续获得稳健的资产收益，实现可持续增长，全面保障投资安全与投资回报稳定性。"
      ]
    }
  },
  image: "/images/solutions/touzi.png"
};

const investmentProducts = {
  title: "我们的产品",
  subtitle: "投资管理解决方案",
  products: productsData.investmentProducts
};

const Investment = () => {
  return (
    <div className="investment-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...investmentContent} />
      <ProductList {...investmentProducts} />
      <div className='mt-auto' style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Investment; 